import { useMemo } from 'react';
import { Season } from '../../apiService';
import Select from '../../Select';
import { SelectInputProps } from '../../SelectInput';
import {  Text } from '../../styles';
import { getEpisodeIdentifier } from '../../utils';

type SeasonSelectorProps = {
  seasons: Season[];
  active: number;
  onChange: (season: number) => void;
};

const SeasonSelector = ({ seasons, active, onChange }: SeasonSelectorProps) => {
  const options = useMemo(() => seasons.map(({ season = 0 }, idx) => ({
    value: idx,
    label: getEpisodeIdentifier({ season }),
  })), [seasons]);

  const handleChange: SelectInputProps['onChange'] = (e) => {
    onChange(Number(e.target.value));
  };

  return (
    <>
      {seasons.length > 1 && (
        <Select
          options={options}
          value={active}
          onChange={handleChange}
          mr={2}
          mb={1}
          inputSize="small"
          renderValue={<RenderValue value={active + 1} length={seasons.length} />}
        />
      )}
    </>
  );
};

const RenderValue = ({ value, length }: { value: number; length: number }) => (
  <div>
    <Text variant="body1" as="span" weight="medium">
      {getEpisodeIdentifier({ season: value })}
    </Text>
    <Text variant="body2" as="span" color="weak" mr={1}>
      از {length}
    </Text>
  </div>
);

export default SeasonSelector;
